import { FormBuilder, Form, FormGroup, FormArray } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-campus-greetings',
  templateUrl: './campus-greetings.component.html',
  styleUrls: ['./campus-greetings.component.css'],
})
export class CampusGreetingsComponent implements OnInit {
  mytime;
  greetingTitle = '';
  allRanges;
  form: FormGroup;
  days: FormArray;
  submitted = true;
  merchantDetail;
  iswelcomeMessage: any;
  greetingData: any;
  newVal: number = 25;
  private parseHHmmToDate(hhmm: string): Date | null {
    if (!hhmm || typeof hhmm !== 'string') {
      return null;
    }
    const [hhStr, mmStr] = hhmm.split(':');
    const hours = Number(hhStr);
    const minutes = Number(mmStr);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
      return null;
    }
    const d = new Date();
    d.setHours(hours, minutes, 0, 0);
    return d;
  }

  private formatDateToHHmm(value: any): string {
    if (!(value instanceof Date)) {
      return '';
    }
    const h = value.getHours();
    const m = value.getMinutes();
    const hh = h < 10 ? `0${h}` : `${h}`;
    const mm = m < 10 ? `0${m}` : `${m}`;
    return `${hh}:${mm}`;
  }

  private getMidnight(): Date {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }

  private buildPayload() {
    const raw = this.form.getRawValue();
    if (Array.isArray(raw.days)) {
      raw.days = raw.days.map((d) => {
        if (d.is24Hours) {
          return { ...d, StartTime: '00:00', EndTime: '00:00' };
        }
        return {
          ...d,
          StartTime: this.formatDateToHHmm(d.StartTime),
          EndTime: this.formatDateToHHmm(d.EndTime),
        };
      });
    }
    return raw;
  }
  constructor(
    private fb: FormBuilder,
    private authService: AuthenticationService
  ) { }

  arr = [
    {
      day: 'Monday',
      isSelected: true,
      is24Hours: false,
    },
    {
      day: 'Tuesday',
      isSelected: true,
      is24Hours: false,
    },
    {
      day: 'Wednesday',
      isSelected: true,
      is24Hours: false,
    },
    {
      day: 'Thursday',
      isSelected: true,
      is24Hours: false,
    },
    {
      day: 'Friday',
      isSelected: true,
      is24Hours: false,
    },
    {
      day: 'Saturday',
      isSelected: true,
      is24Hours: false,
    },
    {
      day: 'Sunday',
      isSelected: true,
      is24Hours: false,
    },
  ];

  ngOnInit(): void {
    this.getCampusGreeting();


    this.form = this.fb.group({
      welcomeMessages: ['', { disabled: false }],
      radius: [0],
      days: new FormArray([]),
      iswelcomeMessage: [true]
    });
    for (let i = 0; i < 7; ++i) {
      this.createItem(this.arr[i]);
    }

    this.merchantDetail = this.authService.currentUserValue;



  }

  get f() {
    return this.form.controls;
  }
  get item() {
    return <FormArray>this.form.controls['days'];
  }

  createItem(props) {
    this.item.push(
      this.fb.group({
        dayName: [props.day],
        isDaysSelected: [props.isSelected],
        is24Hours: [props.is24Hours],
        StartTime: [{ value: null, disabled: props.is24Hours }],
        EndTime: [{ value: null, disabled: props.is24Hours }],
      })
    );
  }

  onChange(event, key, i) {
    if (!event.target.checked && key == 'hours') {
      this.arr[i].is24Hours = false;
      const dayGroup = (this.form.get('days') as FormArray).at(i) as FormGroup;
      dayGroup.get('StartTime')?.enable({ emitEvent: false });
      dayGroup.get('EndTime')?.enable({ emitEvent: false });
    } else if (event.target.checked && key == 'hours') {
      this.arr[i].is24Hours = true;
      const dayGroup = (this.form.get('days') as FormArray).at(i) as FormGroup;
      // When 24 Hours is selected, set both to 00:00 and disable
      dayGroup.get('StartTime')?.setValue(this.getMidnight(), { emitEvent: false });
      dayGroup.get('EndTime')?.setValue(this.getMidnight(), { emitEvent: false });
      dayGroup.get('StartTime')?.disable({ emitEvent: false });
      dayGroup.get('EndTime')?.disable({ emitEvent: false });
    }
  }

  getCampusGreeting() {
    this.authService.getcampusGreeting().subscribe(
      (res) => {

        let data = res['data'];
        let objtest =  data == null || Object.keys(data).length === 0;
        if (!objtest) {
          const CONTROL = this.form.controls;

          for (const props in CONTROL) {
            CONTROL[props].patchValue(data[props]);
          }
          if (Array.isArray(data.days)) {
            const daysFA = this.form.get('days') as FormArray;
            data.days.forEach((d, idx) => {
              // Keep mirror array consistent (used for labels only)
              if (this.arr[idx]) {
                this.arr[idx].is24Hours = !!d.is24Hours;
              }
              const dayGroup = daysFA.at(idx) as FormGroup;
              if (d.is24Hours) {
                dayGroup.get('StartTime')?.disable({ emitEvent: false });
                dayGroup.get('EndTime')?.disable({ emitEvent: false });
                dayGroup.get('StartTime')?.setValue(this.getMidnight(), { emitEvent: false });
                dayGroup.get('EndTime')?.setValue(this.getMidnight(), { emitEvent: false });
              } else {
                dayGroup.get('StartTime')?.enable({ emitEvent: false });
                dayGroup.get('EndTime')?.enable({ emitEvent: false });
                const start = this.parseHHmmToDate(d.StartTime);
                const end = this.parseHHmmToDate(d.EndTime);
                dayGroup.get('StartTime')?.setValue(start, { emitEvent: false });
                dayGroup.get('EndTime')?.setValue(end, { emitEvent: false });
              }
            });
          }
        }
        if(data?.radius) {
          this.newVal = data.radius
          this.form.patchValue(data.radius)
        }
        // if(data?.iswelcomeMessage){
        //   this.form.controls['welcomeMessages'].disable();
        // }

        if (data?.iswelcomeMessage !== undefined) {
          // Handle the case based on the data value
          this.form.controls['iswelcomeMessage'].patchValue(data.iswelcomeMessage);
          if (data.iswelcomeMessage) {
            this.form.controls['welcomeMessages'].disable();
          } else {
            this.form.controls['welcomeMessages'].enable();
          }
        }

      },

      (error) => {
        console.log(error);
      }
    );
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }
    const payload = this.buildPayload();
    this.authService.campusGreeting(payload).subscribe(
      (res: any) => {
        this.authService.successMessage(res.message, 'success').then((res) => {
          if (res.value) {
            this.getCampusGreeting();
          }
        });
      },

      (error) => {
        this.authService.successMessage(error.error.message, 'error');
      }
    );
  }

  setRange() {
    this.allRanges = document.querySelectorAll('.range-wrap');
    this.allRanges.forEach((e) => {
      const range = e.querySelector('.custom-range');
      const bubble = e.querySelector('.bubble');

      this.setBubble(range, bubble);
    });
  }
  setBubble(range, bubble) {
    const val = range.value;
    const min = range.min ? range.min : 0;
    const max = range.max ? range.max : 100;
    const newVal = Number(((val - min) * 100) / (max - min));
    this.newVal = val;
    bubble.innerHTML = val;
    bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
  }

  // isWelcomeMessage(event: any) {
  //   if (event.target.checked) {
  //     this.iswelcomeMessage = false;
  //     // this.form.controls['welcomeMessages'].disable();
  //   }
  //   else {
  //     this.iswelcomeMessage = true;
  //     this.form.controls['welcomeMessages'].enable();
  //   }
  // }

  isWelcomeMessage(event: any) {
    if (event.target.checked) {
      this.authService.campusGreeting(this.buildPayload()).subscribe(
        (res: any) => {
          this.form.controls['welcomeMessages'].disable();
          this.iswelcomeMessage = true;
          res.data.iswelcomeMessage = this.iswelcomeMessage
        }
      )
    } else {
      this.authService.campusGreeting(this.buildPayload()).subscribe(
        (res: any) => {
          this.iswelcomeMessage = false;
          this.form.controls['welcomeMessages'].enable();
          res.data.iswelcomeMessage = this.iswelcomeMessage
        }
      )
    }
  }

}
